import {
  entryType,
  modeOfTransportation,
  actionCode
} from './options';

const entry = [
  {
    name: 'importerOfRecordNumber',
    label: 'Importer of Record Number',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '32-043479200',
    required: false,
    disabled: false,
    icon: undefined,    
  },
  {
    name: 'filerCode',
    label: 'Filer Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: 'SY2',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entryNumber',
    label: 'Entry Number',
    type: 'text',
    maxLength: 8,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entryType',
    label: 'Entry Type',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '01',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'transportationMode',
    label: 'Mode of Transportation',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '11',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entryPort',
    label: 'Port of Entry',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '4601',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'arrivalDate',
    label: 'Arrival Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'importDate',
    label: 'Date of Import',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '2025-05-07',
    required: false,
    disabled: false,
    icon: undefined,
  },
];

const amount = [
  {
    name: 'totalAmount',
    label: 'Total Amount',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    readOnly: true,
  },
  {
    name: 'statementDate',
    label: 'Statement Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '2025-05-19',
    required: false,
    disabled: false,
    icon: undefined,
    readOnly: true,
  },
  {
    type: 'new',
  },
  {
    name: 'totalDuty',
    label: 'Total Duty',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'totalMpf',
    label: 'Total MPF',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'totalHmf',
    label: 'Total HMF',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'totalOtherFee',
    label: 'Total Other Fee',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'totalTaxes',
    label: 'Total Taxes',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
];

const government = [
  {
    name: 'fdaRequired',
    label: 'FDA (Required)',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '1',
    required: false,
    disabled: false,
    icon: undefined,    
  },
  {
    name: 'fdaEntered',
    label: 'FDA (Entered)',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '1',
    required: false,
    disabled: false,
    icon: undefined,    
  },
  {
    name: 'epaRequired',
    label: 'EPA (Required)',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '0',
    required: false,
    disabled: false,
    icon: undefined,    
  },
  {
    name: 'epaEntered',
    label: 'EPA (Entered)',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '0',
    required: false,
    disabled: false,
    icon: undefined,    
  },
];

const submission = [
  {
    name: 'actionCode',
    label: 'Action Code',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,    
  },
  /**
  {
    name: 'excludePGA',
    label: 'Exclude PGA',
    type: 'toggle',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
  },**/
];

const optionsMap = {
  entryType: entryType,
  transportationMode: modeOfTransportation,
  actionCode: actionCode
};

export {  
  entry,
  amount,
  government,
  submission,
  optionsMap
};